import React from 'react';
import { ProgressBar } from 'components/Progress/Bar';
import * as S from './Styles';

export const Progress = ({ progress }) => (
    <S.ProgressWrapper>
        {Object.keys(progress).map((key) => (
            <ProgressBar key={key} store={key} progress={Math.round(progress[key])} />
        ))}
    </S.ProgressWrapper>
)
